<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Cvtèque
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des cv</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Card header: actions + count -->
    <div class="afri-card-header">
      <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
        <button *ngIf="buttonsPermission.add" (click)="add(addContent)" class="btn-afri-primary">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          Ajouter
        </button>
        <button *ngIf="buttonsPermission.show" (click)="show(showContent)" class="btn-afri-outline">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          Consulter
        </button>
        <button *ngIf="buttonsPermission.edit" (click)="edit(editContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
          </svg>
          Éditer
        </button>
        <button *ngIf="buttonsPermission.delete" (click)="delete()" class="btn-afri-danger">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
          Supprimer
        </button>
      </div>
      <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
        <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
        élément(s)
        <app-loading [isVisible]="loading2"></app-loading>
      </div>
    </div>

    <!-- Table -->
    <div style="overflow-x: auto;">
      <table class="afri-table">
        <thead>
          <tr>
            <th style="width: 52px; padding-left: 1.5rem;">#</th>
            <th>Profession</th>
            <th>Année d'expérience</th>
            <th>Localisation</th>
            <th>Type Contrat</th>
            <th>Niveau d'apprentissage</th>
            <th>Visibilité</th>
            <th>Fichier</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of data | paginate: {
                id: 'ngxP1',
                itemsPerPage: pg.pageSize,
                currentPage: pg.p,
                totalItems: pg.total
              } | sampleSearch:search_text"
              [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
            <td style="padding-left: 1.5rem;">
              <input (click)="checked(d)" type="radio" name="selectRow"
                     style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
            </td>
            <td>{{d.job_title}}</td>
            <td>{{d.experience_years}}</td>
            <td>{{d.location}}</td>
            <td>{{d.contract_type}}</td>
            <td>{{d.education_level}}</td>
            <td>
              <app-status [value]="d.visibility"></app-status>
            </td>
            <td>
              <a target="_blank" href="{{d.cv_file}}" class="btn-afri-danger" style="display:inline-flex; align-items:center; gap:0.25rem; padding: 0.25rem 0.75rem; font-size:0.75rem;">Lire le fichier</a>
            </td>
          </tr>

          <tr *ngIf="data.length === 0 && !loading2">
            <td colspan="8" style="padding: 4rem 1.25rem; text-align: center;">
              <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
                <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div style="padding: 0.5rem 1.5rem 1.25rem;">
      <pagination-controls
        id="ngxP1"
        (pageChange)="getPage($event)"
        [maxSize]="9"
        [directionLinks]="true"
        [autoHide]="true"
        [responsive]="true"
        [previousLabel]="'Précédent'"
        [nextLabel]="'Suivant'">
      </pagination-controls>
    </div>

  </div><!-- end card -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
  <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Ajouter un cv</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Nom <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="lastname" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Prénom(s) <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="firstname" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Email <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="email" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Contact <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="phone" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Age <span class="text-danger ml-2">(*)</span></label>
          <input type="integer" name="age" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Mobilité <span class="text-danger ml-2">(*)</span></label>
          <select name="mobility" class="afri-input" ngModel>
            <option value="Local">Local</option>
            <option value="Internationale">Internationale</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Disponibilité <span class="text-danger ml-2">(*)</span></label>
          <select name="availability" class="afri-input" ngModel>
            <option value="Immédiate">Immédiate</option>
            <option value="A discuter">A discuter</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Profil professionnel <span class="text-danger ml-2">(*)</span></label>
          <textarea name="profesional_profil" class="afri-input" ngModel></textarea>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Expérience professionnelle <span class="text-danger ml-2">(*)</span></label>
          <textarea name="work_experience" class="afri-input" ngModel></textarea>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Formation <span class="text-danger ml-2">(*)</span></label>
          <textarea name="formations" class="afri-input" ngModel></textarea>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Profession <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="job_title" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Année d'expérience <span class="text-danger ml-2">(*)</span></label>
          <input type="number" name="experience_years" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Localisation <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="location" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Type de contrat <span class="text-danger ml-2">(*)</span></label>
          <select name="contract_type" class="afri-input" ngModel>
            <option value="CDI">CDI</option>
            <option value="CDD">CDD</option>
            <option value="Freelance">Freelance</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Niveau d'apprentissage <span class="text-danger ml-2">(*)</span></label>
          <select name="education_level" class="afri-input" ngModel>
            <option value="Bac">Bac</option>
            <option value="Licence">Licence</option>
            <option value="Master">Master</option>
            <option value="Doctorat">Doctorat</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Visibilité <span class="text-danger ml-2">(*)</span></label>
          <select name="visibility" class="afri-input" ngModel>
            <option value="public">Public</option>
            <option value="payant">Payant</option>
            <option value="privé">Privé</option>
          </select>
        </div>
        <hr>
        <h6>Ajout des compétences</h6>
        <div class="input-group mb-3">
          <input type="text" name="skill" [(ngModel)]="skill" class="afri-input" placeholder="Saisir un contenu">
          <div class="input-group-append">
            <button class="btn-afri-outline" type="button" (click)="addSkill()">Ajouter</button>
          </div>
        </div>
        <ul>
          <li *ngFor="let sk of skills; let i=index">
            <div class="input-group mb-3">
              <input type="text" name="sk" [ngModel]="sk" readonly class="afri-input">
              <div class="input-group-append">
                <button class="btn-afri-danger" type="button" (click)="removeSkill(i)"><i class="fa fa-times"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <h6>Langues</h6>
        <div class="input-group mb-3">
          <input type="text" name="language" [(ngModel)]="language" class="afri-input" placeholder="Saisir un contenu">
          <div class="input-group-append">
            <button class="btn-afri-outline" type="button" (click)="addLanguage()">Ajouter</button>
          </div>
        </div>
        <ul>
          <li *ngFor="let l of languages; let i=index">
            <div class="input-group mb-3">
              <input type="text" name="l" [ngModel]="l" readonly class="afri-input">
              <div class="input-group-append">
                <button class="btn-afri-danger" type="button" (click)="removeLanguage(i)"><i class="fa fa-times"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <div class="d-flex justify-content-between">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="can_generated" [(ngModel)]="can_generated" [value]="0" id="radioDefault1">
            <label class="afri-label" for="radioDefault1">Fichier (CV)</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="can_generated" [(ngModel)]="can_generated" [value]="1" id="radioDefault2">
            <label class="afri-label" for="radioDefault2">Généré depuis le template Afrilink</label>
          </div>
        </div>
        <div *ngIf="!can_generated" class="col-12 mb-3">
          <label class="afri-label">CV <span class="text-danger ml-2">(*)</span></label>
          <input type="file" class="afri-input" accept="pdf" (change)="upload($event)">
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="addForm.invalid">Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #editContent let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Modifier le CV</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Nom <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="lastname" class="afri-input" [(ngModel)]="selected_data.lastname">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Prénom(s) <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="firstname" class="afri-input" [(ngModel)]="selected_data.firstname">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Email <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="email" class="afri-input" [(ngModel)]="selected_data.email">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Contact <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="phone" class="afri-input" [(ngModel)]="selected_data.phone">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Age <span class="text-danger ml-2">(*)</span></label>
          <input type="integer" min="10" name="age" class="afri-input" [(ngModel)]="selected_data.age">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Mobilité <span class="text-danger ml-2">(*)</span></label>
          <select name="mobility" class="afri-input" [(ngModel)]="selected_data.mobility">
            <option value="Local">Local</option>
            <option value="Internationale">Internationale</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Disponibilité <span class="text-danger ml-2">(*)</span></label>
          <select name="availability" class="afri-input" [(ngModel)]="selected_data.availability">
            <option value="Immédiate">Immédiate</option>
            <option value="A discuter">A discuter</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Profil professionnel <span class="text-danger ml-2">(*)</span></label>
          <textarea name="profesional_profil" class="afri-input" [(ngModel)]="selected_data.profesional_profil"></textarea>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Expérience professionnelle <span class="text-danger ml-2">(*)</span></label>
          <textarea name="work_experience" class="afri-input" [(ngModel)]="selected_data.work_experience"></textarea>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Formation <span class="text-danger ml-2">(*)</span></label>
          <textarea name="formations" class="afri-input" [(ngModel)]="selected_data.formations"></textarea>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Profession <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="job_title" class="afri-input" [(ngModel)]="selected_data.job_title">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Année d'expérience <span class="text-danger ml-2">(*)</span></label>
          <input type="number" name="experience_years" class="afri-input" [(ngModel)]="selected_data.experience_years">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Localisation <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="location" class="afri-input" [(ngModel)]="selected_data.location">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Type de contrat <span class="text-danger ml-2">(*)</span></label>
          <select name="contract_type" class="afri-input" [(ngModel)]="selected_data.contract_type">
            <option value="CDI">CDI</option>
            <option value="CDD">CDD</option>
            <option value="Freelance">Freelance</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Niveau d'apprentissage <span class="text-danger ml-2">(*)</span></label>
          <select name="education_level" class="afri-input" [(ngModel)]="selected_data.education_level">
            <option value="Bac">Bac</option>
            <option value="Licence">Licence</option>
            <option value="Master">Master</option>
            <option value="Doctorat">Doctorat</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Visibilité <span class="text-danger ml-2">(*)</span></label>
          <select name="visibility" class="afri-input" [(ngModel)]="selected_data.visibility">
            <option value="public">Public</option>
            <option value="payant">Payant</option>
            <option value="privé">Privé</option>
          </select>
        </div>
        <hr>
        <h6>Ajout des compétences</h6>
        <div class="input-group mb-3">
          <input type="text" name="skill" [ngModel]="skill" class="afri-input" placeholder="Saisir un contenu">
          <div class="input-group-append">
            <button class="btn-afri-outline" type="button" (click)="addSkill()">Ajouter</button>
          </div>
        </div>
        <ul>
          <li *ngFor="let sk of skills; let i=index">
            <div class="input-group mb-3">
              <input type="text" name="sk" [ngModel]="sk" readonly class="afri-input">
              <div class="input-group-append">
                <button class="btn-afri-danger" type="button" (click)="removeSkill(i)"><i class="fa fa-times"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <h6>Ajout de langue</h6>
        <div class="input-group mb-3">
          <input type="text" name="language" [ngModel]="language" class="afri-input" placeholder="Saisir un contenu">
          <div class="input-group-append">
            <button class="btn-afri-outline" type="button" (click)="addLanguage()">Ajouter</button>
          </div>
        </div>
        <ul>
          <li *ngFor="let l of languages; let i=index">
            <div class="input-group mb-3">
              <input type="text" name="l" [ngModel]="l" readonly class="afri-input">
              <div class="input-group-append">
                <button class="btn-afri-danger" type="button" (click)="removeLanguage(i)"><i class="fa fa-times"></i></button>
              </div>
            </div>
          </li>
        </ul>
        <div class="d-flex justify-content-between">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="can_generated" [(ngModel)]="can_generated" [value]="0" id="radioDefault1">
            <label class="afri-label" for="radioDefault1">Fichier (CV)</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="can_generated" [(ngModel)]="can_generated" [value]="1" id="radioDefault2">
            <label class="afri-label" for="radioDefault2">Généré depuis le template Afrilink</label>
          </div>
        </div>
        <div class="col-12 mb-3" *ngIf="!can_generated">
          <label class="afri-label">CV <span class="text-danger ml-2">(*)</span></label>
          <input type="file" class="afri-input" accept="pdf" (change)="upload($event)">
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #showContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12"><dt>Profession</dt><dd>{{selected_data?.job_title}}</dd></div>
      <div class="col-12"><dt>Année d'expérience</dt><dd>{{selected_data?.experience_years}}</dd></div>
      <div class="col-12"><dt>Localisation</dt><dd>{{selected_data?.location}}</dd></div>
      <div class="col-12"><dt>Type de contrat</dt><dd>{{selected_data?.contract_type}}</dd></div>
      <div class="col-12"><dt>Niveau d'apprentissage</dt><dd>{{selected_data?.education_level}}</dd></div>
      <div class="col-12">
        <dt>Compétences</dt>
        <dd><ul><li *ngFor="let sk of skills">{{sk}}</li></ul></dd>
      </div>
      <div class="col-12">
        <dt>Visibilité</dt>
        <dd><app-status [value]="selected_data.visibility"></app-status></dd>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #contentPDF let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title">Visualiseur de fichier</h4>
    <button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
  </div>
  <div class="offcanvas-body">
    <ngx-extended-pdf-viewer [src]="pdfSrc" style="width: 100%; height: 100%"></ngx-extended-pdf-viewer>
  </div>
</ng-template>
